import { render } from "./Contracts.vue?vue&type=template&id=70bd5495&scoped=true&ts=true"
import script from "./Contracts.vue?vue&type=script&lang=ts"
export * from "./Contracts.vue?vue&type=script&lang=ts"

import "./Contracts.vue?vue&type=style&index=0&id=70bd5495&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70bd5495"]])

export default __exports__